import React, { useEffect, useState } from 'react'
import slugify from 'slugify'

import GetOffsetEl from '../utils/getOffsetEl'

import ChevronIcon from '../icons/chevron-right.svg'

const Anchors = ({sections, activeItem, activeItemTitle, isSticky, isBottomed, isOffer}) => {
  const [anchorsToggled, setAnchorsToggled] = useState(false)

  const goToAnchor = (e) => {
    e.preventDefault()
    const targetSection = document.querySelector(e.target.dataset.anchor)
    let targetOffset = GetOffsetEl(targetSection)
    let offset = window.innerWidth < 1024 ? 64 : 0
    let offsetBg = targetSection.classList.contains('slice--bg') ? 0 : 24
    
    targetOffset -= 104 + offset + offsetBg // height header
    window.scrollTo({
      top: targetOffset,
      behavior: 'smooth'
    })

    setAnchorsToggled(!anchorsToggled)
  }

  useEffect(() => {
    if (!isSticky) {
      setAnchorsToggled(false)
    }
  }, [isSticky])

  const toggleAnchors = () => {
    setAnchorsToggled(!anchorsToggled)
  }
  
  return (
    <nav className={`anchors full-width-left  font-alternate ${isSticky ? 'is-sticky' : ''} ${isBottomed ? 'is-bottomed' : ''}`}>
      <button className={`anchors__button ${anchorsToggled && isSticky ? 'is-active' : ''} `} onClick={() => toggleAnchors()}>
        {activeItemTitle}
        <svg className="icon-night icon pointer-events-none" width="32" height="32">
          <use xlinkHref={ChevronIcon.url} />
        </svg>
      </button>
      <ul className={`anchors__list ${anchorsToggled && isSticky ? 'is-active' : ''}`}>
        {sections.map((section, i) => {
          const slugItem = slugify(section, {remove: /[*+~.,()'"!?:@,]/g}).toLocaleLowerCase()

          return (
            <li key={(i)} className="anchors__item">
              <a href={`#${slugItem}`} data-anchor={`#${slugItem}`} onClick={(e) => goToAnchor(e)} className={`${activeItem === slugItem ? 'is-active' : ''} anchors__link ${isOffer ? 'anchors__link--offer' : ''}`}>
                {section}
              </a>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Anchors